import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { RegrasContabilizacaoService } from '../../../services/regrasContabilizacaoService';
import { TableAdmin } from '../../../../../components/TableAdmin';
import { BaSeDialogContext, BaSeIcon } from '@base/react';
import { FaRegCheckCircle } from 'react-icons/fa';
import {
  ColumnGap,
  FilterClearButton,
  FilterContainer,
  FlexDirectionWrapper,
  FormInputLabel,
  FormInputRadio,
  FormInputRadioContent,
  MainContent,
  RadioOptionFilter,
  Row,
  SubTitle,
  Text,
  WrapperLegend,
} from '../../../../../components/StyledComponents';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Accordion from '@material-ui/core/Accordion';
import { formatDateToBR } from '../../../../../utils/time';
import { ExcelExportAdmin } from '../../../../../components/ExcelExportAdmin';
import { SearchInputAdmin } from '../../../../../components/SearchInputAdmin';
import { handleModalAdmin } from '../../../../../utils/handleModalAdmin';
import {
  formatInstrumentString, formatStringArray,
  removeEmpty, sortByDirection,
} from '../../../../../utils/utils';
import { useApp } from '../../../../../context/app';
import axios from '../../../../../services/api';
import moment from 'moment';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import { FilterSelectAdmin } from '../../../../../components/FilterSelectAdmin';
import { Grid } from '@mui/material';
import { formatDefaultValueSelect } from '../../../../../utils/mask';
import { FilterDateInputAdmin } from '../../../../../components/FilterDateInputAdmin';

export const GerenciarRegrasContabilizacao = () => {
  const { setRenderIncludeScreen, setManageItem } = useApp();

  const { showModal } = React.useContext(BaSeDialogContext);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState({});
  const [filterOptions, setFilterOptions] = useState({});
  const [inputSearchValue, setInputSearchValue] = useState('');
  const [pendants, setPendants] = useState(null);
  const [radioUsaDiagnostico, setRadioUsaDiagnostico] = useState(null);
  const [radio2Visita, setRadio2Visita] = useState(null);
  const [radioPublico, setRadioPublico] = useState(null);
  const [orderBy, setOrderBy] = useState(null);
  const [paginationFilters, setPaginationFilters] = useState({
    page: 0,
    linesPerPage: 10,
    orderBy: 'id',
    direction: 'DESC',
  });

  const getBodyParams = () => {
    return removeEmpty({ ...filters, oqueVoceProcura: inputSearchValue });
  };

  const getData = async () => {
    try {
      const bodyParams = getBodyParams();
      const response = await RegrasContabilizacaoService.findAll(
        paginationFilters,
        bodyParams
      );
      getPendants();
      setData(response);
    } catch (e) {
      console.log('erro =>>', e);
    } finally {
      setIsLoading(false);
    }
  };

  const getDataExcel = async () => {
    const source = axios.CancelToken.source();
    const bodyParams = getBodyParams();
    const pageFilter = { ...paginationFilters, page: 0, linesPerPage: 1000 };
    const response = await RegrasContabilizacaoService.findAll(
      pageFilter,
      bodyParams,
      source
    );
    return response?.content?.map((r) => ({
      DATA: r?.dataCriacao ? moment(r?.dataCriacao).format('DD/MM/YYYY') : '',
      NOME_REGRA: r?.nome,
      UF: r?.uf?.sigla,
      PUBLICO: r?.publicos?.map((i) => i.nome),
      INSTRUMENTO: r?.instrumento,
      TEMA: r?.temaMacro?.descricao,
      DURAÇÃO: r?.periodos
        ?.map(
          (i) =>
            `${i.duracao}${
              i.unidadeMedida === 'HORA'
                ? 'h'
                : i.unidadeMedida === 'MINUTO'
                ? 'm'
                : 's'
            }`
        )
        .join(', '),
      PERFIL: r?.perfil?.nome,
      PROJETO: r?.projetos?.map((i) => i.nomePratif),
      STATUS: r?.status,
    }));
  };

  const getPendants = async () => {
    const bodyParams = getBodyParams();
    const response = await RegrasContabilizacaoService.getPedants(bodyParams);
    setPendants(response);
  };

  const getOptionsData = async () => {
    setFilterOptions({});
    const response = await RegrasContabilizacaoService.getOptions(false);
    setFilterOptions(response.data);
  };

  const changeState = async (item) => {
    const status = item.status === 'APROVADO' ? 'REPROVADO' : 'APROVADO';
    return await RegrasContabilizacaoService.changeStatus(item.id, status);
  };

  const onLinesPerPageChange = (value) => {
    setPaginationFilters({
      ...paginationFilters,
      linesPerPage: value,
      page: 0,
    });
  };

  const handlePageChange = (value) => {
    setPaginationFilters({
      ...paginationFilters,
      page: value,
    });
  };

  const handleOrderClick = ({ orderBy, direction }) => {
    setPaginationFilters({
      ...paginationFilters,
      orderBy: orderBy,
      direction: direction,
    });
  };

  const handleInputPageChange = (newValue) => {
    setIsLoading(true);
    setPaginationFilters({
      ...paginationFilters,
      page: newValue,
    });
  };

  const handleFilterByStatus = (status) => {
    if (JSON.stringify(status) === JSON.stringify(filters?.status)) {
      setFilters((f) => ({ ...f, status: null }));
      return;
    }
    setFilters((f) => ({ ...f, status: status }));
    setPaginationFilters({
      ...paginationFilters,
      page: 0,
    });
  };

  const handleStateClick = (item) => {
    handleModalAdmin({
      title: `${
        item.status === 'APROVADO' ? 'Desaprovar' : 'Aprovar'
      } regra de contabilização`,
      content: `Você tem certeza que deseja ${
        item.status === 'APROVADO' ? 'Desaprovar' : 'Aprovar'
      } essa regra de contabilização?`,
      msgOnSuccess: `Regra de contabilização ${
        item.status === 'APROVADO' ? 'Desaprovada' : 'Aprovada'
      } com sucesso`,
      msgOnError: `A regra de contabilização não foi ${
        item.status === 'APROVADO' ? 'Desaprovada' : 'Aprovada'
      } Aconteceu um erro ou o sistema está temporariamente fora do ar. Tente novamente mais tarde.`,
      showAPIErrorIfAvailable: true,
      onFinish: () => {
        setIsLoading(true);
        getData();
      },
      onConfirmClick: () => changeState(item),
      showModal: showModal,
    });
  };

  const handleDeleteClick = (idVersao) => {
    handleModalAdmin({
      title: `Excluir regra de contabilização`,
      content: `Você tem certeza que deseja excluir essa regra de contabilização?`,
      msgOnSuccess: `Regra de contabilização excluída com sucesso`,
      onFinish: () => {
        setIsLoading(true);
        getData();
      },
      onConfirmClick: async () =>
        await RegrasContabilizacaoService.delete(idVersao),
      showModal: showModal,
    });
  };

  const handleEditClick = (item) => {
    setManageItem({
      type: 'edit',
      data: item,
    });
    setRenderIncludeScreen(true);
  };

  const handleCopyClick = (item) => {
    delete item.id;
    setManageItem({
      type: 'copy',
      data: item,
    });
    setRenderIncludeScreen(true);
  };

  const onChangeItemFilter = (event, field) => {
    event.stopPropagation();
    const fieldValue = event.target.value
      ? JSON.parse(event.target.value)
      : event.target.value;
    setFilters({ ...filters, [field]: fieldValue });
  };

  const onChangeOrder = (event) => {
    const value = !!event.target.value ? JSON.parse(event.target.value) : '';
    setOrderBy(value);
    if (value === 'MAIS_RECENTES') {
      setPaginationFilters((p) => ({ ...p, direction: 'DESC', orderBy: 'id' }));
      return;
    }
    setPaginationFilters((p) => ({ ...p, direction: 'ASC', orderBy: 'id' }));
  };

  const onChangeDateItemFilter = (event, field) => {
    event.stopPropagation();
    setFilters({
      ...filters,
      [field]: event.target.value,
      mes: null,
      ano: null,
    });
  };

  const handlePluralUnidade = (value, unidade) => {
    if (!unidade) return '';
    const str = value === 1 ? unidade : `${unidade}S`;
    return formatDefaultValueSelect(str);
  };

  const handleDuracaoOptions = useMemo(() => {
      if(filterOptions) {
        const { duracoesAtendimento } = filterOptions;

        const formated = duracoesAtendimento?.map((d) => ({
          value: {
            duracaoAtendimento: {
              duracao: d.duracao,
              unidadeMedida: d.unidadeMedida,
            }
          },
          description:
              d.duracao + ' ' + handlePluralUnidade(d.duracao, d.unidadeMedida),
        }));
        return formated ?? [];
      }
      return [];
  }, [filterOptions]);

  const selectedDuracao = useCallback(() => {
    if (!(filters.duracao && filters.unidadeMedida)) return;
    const { duracao, unidadeMedida } = filters;
    return handleDuracaoOptions.find(
      ({ value }) =>
        value.duracao === duracao && value.unidadeMedida === unidadeMedida
    );
  }, [filters, handleDuracaoOptions]);

  const handleSelectDuracao = (event) => {
    const selectedOption = !!event.target.value
      ? JSON.parse(event.target.value)
      : '';
    if (selectedOption) {
      const { value } = selectedOption;
      setFilters((p) => ({
        ...p,
        duracaoAtendimento: {
          duracao: value.duracao,
          unidadeMedida: value.unidadeMedida,
      }
      }));
    } else {
      setFilters((p) => ({ ...p, duracao: null, unidadeMedida: null }));
    }
  };

  useEffect(() => {
    setIsLoading(true);
    setData([]);
    getData();
    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationFilters, filters, inputSearchValue]);

  useEffect(() => {
    getOptionsData();
    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tableColumns = [
    {
      field: 'dataCriacao',
      id: 'dataCriacao',
      label: 'Data',
      minWidth: 10,
    },
    {
      field: 'nome',
      id: 'nome',
      label: 'Nome Regra',
      align: 'left',
      columnStyle: {
        overflowWrap: 'break-word',
        width: 320,
        wordBreak: 'break-word',
        whiteSpace: 'break-spaces',
      },
    },
    {
      subfield: 'sigla',
      field: 'uf',
      id: 'uf',
      label: 'UF',
      align: 'left',
    },
    {
      field: 'publicos',
      id: 'publicos',
      label: 'Público',
      align: 'left',
      handleField: (publicos) => publicos.map((p) => p.nome).join(', '),
    },
    {
      field: 'instrumento',
      id: 'instrumento',
      label: 'Instrumento',
      align: 'left',
      handleField: formatInstrumentString,
    },
    {
      field: 'descricao',
      id: 'temaMacro',
      label: 'Tema',
      align: 'left',
    },
    {
      field: 'periodos',
      id: 'periodos',
      label: 'Duração',
      align: 'center',
      minWidth: 50,
      handleField: (d) =>
        d
          .map(
            (i) =>
              `${i.duracao}${
                i.unidadeMedida === 'HORA'
                  ? 'h'
                  : i.unidadeMedida === 'MINUTO'
                  ? 'm'
                  : 's'
              }`
          )
          .join(', '),
    },
    {
      field: 'perfil',
      id: 'perfil',
      label: 'Perfil',
      align: 'left',
      handleField: (perfil) => formatDefaultValueSelect(perfil.nome),
    },
    {
      field: 'projetos',
      id: 'projetos',
      label: 'Projeto',
      align: 'left',
      handleField: (projetos) => projetos.map((i) => i.nomePratif).join(', '),
    },
    {
      field: 'actions',
      id: 'actions',
      label: 'Status',
      minWidth: 150,
      align: 'left',
    },
  ];

  const onClickClearFilters = async () => {
    setIsLoading(true);
    setData([]);
    setPaginationFilters({
      page: 0,
      linesPerPage: 10,
      orderBy: 'id',
      direction: 'DESC',
    });
    setFilters({});
    setInputSearchValue(null);
    setRadioUsaDiagnostico(null);
    setRadioPublico(null);
    setRadio2Visita(null);
    setOrderBy(null);
  };

  const renderFilters = (color) => {
    return (
      <FilterContainer>
        <Accordion style={{ backgroundColor: '#F8F8F8', marginBottom: 20 }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="accordion-filter"
            id="accordion-filter"
          >
            <BaSeIcon
              name="filter"
              color={color}
              size={25}
              description="Ícone de filtro"
            />
            <p style={{ color: color, fontWeight: 'bold' }}>Filtrar</p>
            <FilterClearButton
              color={color}
              onClick={(e) => {
                e.stopPropagation();
                onClickClearFilters();
              }}
            >
              <BaSeIcon
                name="close"
                size={10}
                color={color}
                description="Limpar filtros"
              />
              <p
                style={{
                  fontSize: '12px',
                  color: color,
                  borderBottom: `1px solid ${color}`,
                }}
              >
                Limpar filtros
              </p>
            </FilterClearButton>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container item rowSpacing={1} spacing={1.3}>
              <Grid item md={3}>
                <FilterSelectAdmin
                  label="Tipo Realização"
                  placeholder={'Selecione uma opção'}
                  options={filterOptions?.tipos}
                  value={filters?.tipo}
                  optionLabel={'tipo'}
                  onChangeItem={(event) => onChangeItemFilter(event, 'tipo')}
                />
              </Grid>
              <Grid item md>
                <FilterSelectAdmin
                  label="Perfil do usuário"
                  placeholder={'Selecione uma opção'}
                  options={sortByDirection(filterOptions?.perfis, 'nome')}
                  value={filters?.perfil}
                  optionLabel={'nome'}
                  formatLabel={formatStringArray}
                  returnAsObject={false}
                  onChangeItem={(event) => onChangeItemFilter(event, 'perfil')}
                />
              </Grid>
              <Grid item md>
                <FilterSelectAdmin
                  label="Instrumento"
                  placeholder={'Selecione uma opção'}
                  formatLabel={formatInstrumentString}
                  options={sortByDirection(filterOptions?.instrumentos)}
                  value={filters?.instrumento}
                  onChangeItem={(event) =>
                    onChangeItemFilter(event, 'instrumento')
                  }
                />
              </Grid>
              <Grid item md>
                <FilterSelectAdmin
                  label="Ordenar por"
                  placeholder={'Selecione uma opção'}
                  options={['MAIS_RECENTES']}
                  formatLabel={formatStringArray}
                  value={orderBy}
                  onChangeItem={(event) => onChangeOrder(event)}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
          <AccordionDetails>
            <Grid container item rowSpacing={1} spacing={1.3}>
              <Grid item md={3}>
                <FilterSelectAdmin
                  label="Tema"
                  placeholder={'Selecione um tema'}
                  options={filterOptions?.temasMacro}
                  value={filters?.temaMacro}
                  optionLabel={'descricao'}
                  onChangeItem={(event) =>
                    onChangeItemFilter(event, 'temaMacro')
                  }
                />
              </Grid>
              <Grid item md>
                <FilterSelectAdmin
                  label="Duração"
                  placeholder={'Selecione um duração'}
                  optionLabel={'description'}
                  options={handleDuracaoOptions}
                  value={selectedDuracao()}
                  onChangeItem={(event) => handleSelectDuracao(event)}
                />
              </Grid>
              <Grid
                item
                md={2}
                xs={2}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <div>
                  <FormInputLabel>
                    <label>Usa diagnóstico?</label>
                  </FormInputLabel>
                  <FormInputRadioContent>
                    <FormInputRadio
                      type="radio"
                      value="Sim"
                      checked={radioUsaDiagnostico}
                      onChange={() => {
                        setRadioUsaDiagnostico(true);
                      }}
                    />
                    <RadioOptionFilter>Sim</RadioOptionFilter>

                    <FormInputRadio
                      type="radio"
                      value="Não"
                      checked={
                        !radioUsaDiagnostico && radioUsaDiagnostico !== null
                      }
                      onChange={() => {
                        setFilters((f) => ({
                          ...f,
                          diagnostico: null,
                          isDiagnostico: false,
                        }));
                        setRadioUsaDiagnostico(false);
                      }}
                    />
                    <RadioOptionFilter>Não</RadioOptionFilter>
                  </FormInputRadioContent>
                </div>
              </Grid>
              <Grid item md>
                {!!radioUsaDiagnostico && (
                  <FilterSelectAdmin
                    placeholder={'Selecione um diagnóstico'}
                    options={filterOptions?.diagnosticos}
                    value={filters?.diagnostico}
                    optionLabel={'titulo'}
                    onChangeItem={async (event) => {
                      onChangeItemFilter(event, 'diagnostico');
                      setFilters((f) => ({ ...f, isDiagnostico: true }));
                    }}
                  />
                )}
              </Grid>
            </Grid>
          </AccordionDetails>

          <AccordionDetails>
            <Grid container item rowSpacing={1} spacing={1.3}>
              <Grid item md={3} xs={2}>
                <FilterSelectAdmin
                  label="UF"
                  placeholder={'NA'}
                  options={sortByDirection(filterOptions?.ufs, 'sigla')}
                  value={filters?.uf}
                  optionLabel={'sigla'}
                  onChangeItem={(event) => onChangeItemFilter(event, 'uf')}
                />
              </Grid>
              <Grid item md={2} xs={2}>
                <div>
                  <FormInputLabel
                    style={{
                      marginBottom: '9px',
                      marginTop: '0px',
                    }}
                  >
                    <label>Público</label>
                  </FormInputLabel>
                  <FormInputRadioContent>
                    {filterOptions?.publicos?.map((p, index) => (
                      <div
                        key={index}
                        style={{
                          justifyContent: 'center',
                          alignItems: 'center',
                          display: 'flex',
                        }}
                      >
                        <FormInputRadio
                          type="radio"
                          value={p.nome}
                          checked={radioPublico === p.nome}
                          onChange={() => {
                            setRadioPublico(p.nome);
                            setFilters((fil) => ({ ...fil, publico: p }));
                          }}
                        />
                        <RadioOptionFilter>{p.nome}</RadioOptionFilter>
                      </div>
                    ))}
                  </FormInputRadioContent>
                </div>
              </Grid>
              <Grid
                item
                md={2}
                xs={2}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <div>
                  <FormInputLabel>
                    <label>2 visita</label>
                  </FormInputLabel>
                  <FormInputRadioContent>
                    <FormInputRadio
                      type="radio"
                      value="Sim"
                      checked={radio2Visita}
                      onChange={() => {
                        setFilters((f) => ({
                          ...f,
                          habilitarSegundaVisita: true,
                        }));
                        setRadio2Visita(true);
                      }}
                    />
                    <RadioOptionFilter>Sim</RadioOptionFilter>

                    <FormInputRadio
                      type="radio"
                      value="Não"
                      checked={!radio2Visita && radio2Visita !== null}
                      onChange={() => {
                        setFilters((f) => ({
                          ...f,
                          habilitarSegundaVisita: false,
                        }));
                        setRadio2Visita(false);
                      }}
                    />
                    <RadioOptionFilter>Não</RadioOptionFilter>
                  </FormInputRadioContent>
                </div>
              </Grid>
            </Grid>
          </AccordionDetails>

          <AccordionDetails>
            <Grid container item rowSpacing={1} spacing={1.3}>
              <Grid item md>
                <FilterSelectAdmin
                  label="Data"
                  options={filterOptions?.atributosData}
                  optionLabel={'descricao'}
                  value={filters?.tipoAtributoData}
                  placeholder={'Selecione uma opção'}
                  onChangeItem={(event) =>
                    onChangeItemFilter(event, 'tipoAtributoData')
                  }
                />
              </Grid>
              <Grid item md>
                <FilterDateInputAdmin
                  label={'Data inicial'}
                  value={filters?.dataInicial}
                  onChangeItem={(event) =>
                    onChangeDateItemFilter(event, 'dataInicial')
                  }
                />
              </Grid>

              <Grid item md>
                <FilterDateInputAdmin
                  label={'Data final'}
                  value={filters?.dataFinal}
                  onChangeItem={(event) =>
                    onChangeDateItemFilter(event, 'dataFinal')
                  }
                />
              </Grid>

              <Grid item md>
                <FilterSelectAdmin
                  label="Mês"
                  placeholder={'Selecione um mês'}
                  value={filters?.mes}
                  options={filterOptions?.meses}
                  formatLabel={formatDefaultValueSelect}
                  onChangeItem={(event) => {
                    event.stopPropagation();
                    const value = !!event.target.value
                      ? JSON.parse(event.target.value)
                      : '';
                    setFilters({
                      ...filters,
                      dataInicial: null,
                      dataFinal: null,
                      mes: value,
                    });
                  }}
                />
              </Grid>

              <Grid item md>
                <FilterSelectAdmin
                  label="Ano"
                  placeholder={'Selecione um ano'}
                  options={filterOptions?.anos}
                  value={filters?.ano}
                  onChangeItem={async (event) => {
                    event.stopPropagation();
                    const value = !!event.target.value
                      ? JSON.parse(event.target.value)
                      : '';
                    setFilters({
                      ...filters,
                      dataInicial: null,
                      dataFinal: null,
                      ano: value,
                    });
                  }}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </FilterContainer>
    );
  };

  return (
    <MainContent>
      <SubTitle>
        <>
          <h3>Gerenciar</h3>
          <SearchInputAdmin
            value={inputSearchValue}
            onChange={setInputSearchValue}
          />
        </>
      </SubTitle>

      {renderFilters('#B3B3B3')}

      <WrapperLegend>
        <ColumnGap
          gap="7px"
          padding="6px 10px"
          backgroundColor={!!pendants && 'rgba(196, 196, 196, 0.2)'}
        >
          {!!pendants && (
            <>
              <BaSeIcon
                name="exclamation-circle"
                size={28}
                color="#ff0000"
                description={'Gerenciamento'}
              />
              <Row align="center">
                <Text color="#B3B3B3">Existem&nbsp;</Text>
                <Text color="#ff0000" weight="bold">
                  {pendants} &nbsp;
                </Text>
                <Text color="#B3B3B3">itens aguardando aprovação.</Text>
              </Row>
            </>
          )}
        </ColumnGap>

        <ColumnGap gap="17px">
          <ColumnGap
            align="center"
            gap="8px"
            onClick={() => handleFilterByStatus(['APROVADO'])}
          >
            <FaRegCheckCircle size={25} color="#0061C6" />
            <Text
              color={
                filters?.status?.includes('APROVADO') ? 'black' : '#B3B3B3'
              }
            >
              Aprovado
            </Text>
          </ColumnGap>
          <ColumnGap
            align="center"
            gap="8px"
            onClick={() => handleFilterByStatus(['PENDENTE', 'REPROVADO'])}
          >
            <FaRegCheckCircle size={25} color="#FF0000" />
            <Text
              color={
                filters?.status?.includes('PENDENTE') ? 'black' : '#B3B3B3'
              }
            >
              Aguardando aprovação
            </Text>
          </ColumnGap>
        </ColumnGap>
      </WrapperLegend>

      <FlexDirectionWrapper
        style={{ justifyContent: 'space-between', marginTop: '12px' }}
      >
        <ColumnGap gap="4px">
          <Text color="#0061C6" weight="bold">
            {data?.totalElements ?? 0}
          </Text>
          <Text color="#B3B3B3">
            {data?.totalElements === 1 ? 'resultado' : 'resultados'} encontrados
          </Text>
        </ColumnGap>

        <ExcelExportAdmin
          filename={`Exportacao_Regras_Contabilizacao_${formatDateToBR(
            new Date()
          )}`}
          handleDataCallback={getDataExcel}
          isCsv
        />
      </FlexDirectionWrapper>

      <TableAdmin
        {...{
          data,
          paginationFilters,
          isLoading,
          onLinesPerPageChange,
          handleDeleteClick,
          handleEditClick,
          handleCopyClick,
          handleOrderClick,
          handleStateClick,
        }}
        sentEntireObjectToEdit
        sentEntireObjectToCopy
        columnAction={'actions'}
        linesPerPageFilters={paginationFilters?.linesPerPage}
        pagination={true}
        totalPages={data?.totalPages}
        columns={tableColumns}
        tableColor={'#0061C6'}
        lineColor={'rgba(0, 97, 198, 0.1)'}
        onPagePreviousChange={handlePageChange}
        onPageNextChange={handlePageChange}
        onInputPageChange={handleInputPageChange}
      />
    </MainContent>
  );
};
